import React, { useEffect, useState, useRef } from "react";
import AdminLayout from "../../UI/Layout/AdminLayout";
import Spining from "../../UI/Spining/Spining";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import Axios from "../../../axios/Axios";
import { NODE_HOST_URL } from "../../Dashboard/api/Api";
import { userloginDetails } from "../../Utils/AdminAuth";
import EmptyImg from "../../Dashboard/assets/img/create-project.png"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf, faSearch } from "@fortawesome/free-solid-svg-icons";

const RcsRequestDetails = () => {
    const lStorage = userloginDetails();
    const userId = lStorage?.user?.userId;
    const userToken = lStorage?.token;
    const [loading, setLoading] = useState(false);
    const [listData, setListData] = useState('');
    const { id } = useParams()
    const printRef = useRef();
    useEffect(() => {
        fetchRcsOnboardingList();
    }, []);

    const fetchRcsOnboardingList = async () => {
        setLoading(true);
        try {
            const dataForList = {
                user_id: userId,
                token: userToken,
                method: "onboarding_dtl",
                id: id
            };
            const { data } = await Axios.post(
                `${NODE_HOST_URL}/admin/rcs`,
                dataForList
            );
            if (data.success === true) {
                setListData(data.data);
                // console.log(data.data);

            }
        } catch (error) {
            console.log(error.message);
        }
        setLoading(false)
    };

    const handlePrint = () => {
        const content = printRef.current.innerHTML;
        const printWindow = window.open('', '', 'width=800,height=600');

        printWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>RCS Onboarding Form</title>
        <link
          rel="stylesheet"
          href="https://stackpath.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css"
        />
        <style>
          body {
            font-family: Arial, sans-serif;
            padding: 20px;
          }
        </style>
      </head>
      <body>
        ${content}
      </body>
    </html>
  `);

        // Ensure document is fully written before printing
        printWindow.document.close();

        // Wait until the new window loads styles before printing
        printWindow.onload = () => {
            printWindow.focus();
            printWindow.print();
            printWindow.close();
        };
    };

    console.log(listData);



    return (
        <>
            {loading && <Spining />}
            <AdminLayout>
                <div className="row">
                    <div className="col-3">
                        <h6>Request List Details</h6>
                    </div>
                </div>

                <div className="card">
                    <div className="card-body">
                        {listData ?
                            <>
                                <div className="row">
                                    <div className="col-12">
                                        <button type="button" className="btn btn-danger float-right" onClick={handlePrint}>PDF<FontAwesomeIcon className="ml-2" icon={faFilePdf} /></button>
                                    </div>
                                </div>
                                <div className="container mt-4" ref={printRef}>
                                    <table className="table table-bordered">
                                        <tbody>
                                            <tr>
                                                <th>Display Name (Maximum 40 characters)</th>
                                                <td>{listData.display_name}</td>
                                            </tr>
                                            <tr>
                                                <th>Brand's Tagline</th>
                                                <td>{listData.brand_tagline}</td>
                                            </tr>
                                            <tr>
                                                <th>Colour</th>
                                                <td>{listData.color}</td>
                                            </tr>
                                            <tr>
                                                <th>Banner image Large (1440*448 pixels)</th>
                                                <td><a target="_blank" href={listData.large_image}>{listData.large_image}</a></td>
                                            </tr>
                                            <tr>
                                                <th>Small logo (224 *224 pixels)</th>
                                                <td><a target="_blank" href={listData.logo}>{listData.logo}</a></td>
                                            </tr>
                                            <tr>
                                                <th>List of Regions</th>
                                                <td>{listData.region}</td>
                                            </tr>
                                            <tr>
                                                <th>Business Manager Details</th>
                                                <td>
                                                    Name: {listData.manager_name}<br />
                                                    Designation: {listData.manager_designation}<br />
                                                    Company Email: <a href={listData.manager_company_email}>{listData.manager_company_email}</a><br />
                                                    Phone No.: +91 {listData.manager_phone}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>Primary phone number</th>
                                                <td>+91 {listData.primary_phone}</td>
                                            </tr>
                                            <tr>
                                                <th>Label for primary phone number</th>
                                                <td>{listData.primary_phone_label}</td>
                                            </tr>
                                            <tr>
                                                <th>Primary website</th>
                                                <td><a target="_blank" href={listData.primary_website}>{listData.primary_website}</a></td>
                                            </tr>
                                            <tr>
                                                <th>Label for primary website</th>
                                                <td>{listData.primary_website_label}</td>
                                            </tr>
                                            <tr>
                                                <th>Primary email</th>
                                                <td><a target="_blank" href={listData.primary_email}>{listData.primary_email}</a></td>
                                            </tr>
                                            <tr>
                                                <th>Label for Primary email</th>
                                                <td>{listData.primary_email_label}</td>
                                            </tr>
                                            <tr>
                                                <th>Screenshot</th>
                                                <td>
                                                    {Array.isArray(listData?.screen_shot) &&
                                                        listData.screen_shot.map((url, index) => (
                                                            <div key={index}>
                                                                Image{index + 1}:{" "}
                                                                <a target="_blank" rel="noreferrer" href={url}>
                                                                    {url}
                                                                </a>
                                                            </div>
                                                        ))
                                                    }

                                                </td>
                                            </tr>

                                            <tr>
                                                <th>Privacy policy</th>
                                                <td><a target="_blank" href={listData.privacy_policy}>{listData.privacy_policy}</a></td>
                                            </tr>
                                            <tr>
                                                <th>Aadhar</th>
                                                <td><a target="_blank" href={listData.aadhar}>{listData.aadhar}</a></td>
                                            </tr>
                                            <tr>
                                                <th>Pan</th>
                                                <td><a target="_blank" href={listData.pan}>{listData.pan}</a></td>
                                            </tr>
                                            <tr>
                                                <th>GST</th>
                                                <td><a target="_blank" href={listData.gst}>{listData.gst}</a></td>
                                            </tr>
                                            <tr>
                                                <th>BOT Type</th>
                                                <td>
                                                    {listData?.bot_type &&
                                                        Object.entries(listData.bot_type).map(([key, value]) =>
                                                            value ? (
                                                                <div key={key}>
                                                                    <strong>{key}:</strong> {value}
                                                                </div>
                                                            ) : null
                                                        )}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>Terms of service</th>
                                                <td><a target="_blank" href={listData.terms_service}>{listData.terms_service}</a></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </>
                            :
                            <div className="text-center">
                                <div className="card-body">
                                    <img alt="Empty Data" className="project-empty-img" src={EmptyImg} />
                                    <p>No Data Yet</p>
                                </div>
                            </div>}
                    </div>
                </div>
            </AdminLayout>
        </>
    );
};

export default RcsRequestDetails;